import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SearchIcon, ShoppingCartIcon, UserIcon, HeartIcon, MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { useAuth } from '../../context/AuthContext';
import { Input } from '../ui/Input';
import { formatPrice } from '../../utils/formatters';
export function Header() {
  const {
    itemCount,
    total
  } = useCart();
  const {
    isAuthenticated,
    user
  } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <header className="sticky top-0 z-40 bg-white shadow-sm" data-id="element-365" data-mp="vrebit4tphxn">
      {/* Top bar */}
      <div className="bg-gray-900 text-white text-sm py-2" data-id="element-366" data-mp="qyuzw1pp4wvh">
        <div className="max-w-7xl mx-auto px-4 flex items-center justify-between" data-id="element-367" data-mp="3abrlm6nck3e">
          <div className="flex items-center gap-4" data-id="element-368" data-mp="388u6h35zoon">
            <span className="flex items-center gap-1" data-id="element-369" data-mp="3uflaktw83y3i">
              <PhoneIcon className="w-3.5 h-3.5" data-id="element-370" data-mp="3ues8454arur6" />
              +92-313-2370605
            </span>
            <span className="hidden sm:inline" data-id="element-371" data-mp="6tu9z2q6ubaa">|</span>
            <span className="hidden sm:inline" data-id="element-372" data-mp="btgpjitho3m9">
              Free shipping on orders over PKR 5,000
            </span>
          </div>
          <div className="flex items-center gap-4" data-id="element-373" data-mp="gnudj05tn8gw">
            <Link to="/contact" className="hover:text-primary-300 transition-colors" data-id="element-374" data-mp="ljji5hwp7fk2">
              Help
            </Link>
            <Link to="/track-order" className="hover:text-primary-300 transition-colors" data-id="element-375" data-mp="3k41hl7s5f7q7">
              Track Order
            </Link>
          </div>
        </div>
      </div>

      {/* Main header */}
      <div className="max-w-7xl mx-auto px-4 py-4" data-id="element-376" data-mp="3tz35k0aou3r7">
        <div className="flex items-center justify-between gap-4" data-id="element-377" data-mp="1x3ofzvm6nhh">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0" data-id="element-378" data-mp="19afe8r86swx4">
            <div className="flex items-center gap-2" data-id="element-379" data-mp="199m9twwpaji5">
              <img src="https://cdn.magicpatterns.com/uploads/fRsBpVfPoCHsQawYgHjccg/ChatGPT_Image_Mar_6,_2026,_03_48_02_AM.png" alt="Gadgets Zone" className="h-10 w-auto object-contain" data-id="element-380" data-mp="1db7p1owpj9vi" />
              <div className="hidden sm:block" data-id="element-381" data-mp="35dk5a5rdxb6m">
                <h1 className="text-xl font-bold text-gray-900" data-id="element-382" data-mp="35cs9attvlbft">
                  Gadgets Zone
                </h1>
                <p className="text-xs text-gray-500" data-id="element-383" data-mp="3jayzrowhw95g">
                  Affordable gadgets for everyday life
                </p>
              </div>
            </div>
          </Link>

          {/* Search bar */}
          <div className="flex-1 max-w-2xl hidden md:block" data-id="element-384" data-mp="2qm1hhlsaaccp">
            <div className="relative" data-id="element-385" data-mp="2mo3w6u1mwael">
              <Input type="search" placeholder="Search for products, brands and more..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} leftIcon={<SearchIcon className="w-5 h-5" data-id="element-387" data-mp="2vmp7c44s0n5c" />} className="pr-24" data-id="element-386" data-mp="2mkzjt9e0m8cu" />
              <button className="absolute right-2 top-1/2 -translate-y-1/2 bg-primary-600 text-white px-4 py-1.5 rounded-md text-sm font-medium hover:bg-primary-700 transition-colors" data-id="element-388" data-mp="27xeed8to3x1r">
                Search
              </button>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-2 sm:gap-4" data-id="element-389" data-mp="n7914w967u7d">
            {isAuthenticated ? <Link to="/account" className="hidden sm:flex items-center gap-2 text-gray-700 hover:text-primary-600 transition-colors" data-id="element-390" data-mp="n9c22bbv37qv">
                <UserIcon className="w-5 h-5" data-id="element-391" data-mp="eee58t5lfau9" />
                <span className="text-sm font-medium" data-id="element-392" data-mp="ed31gtc5e335">
                  {user?.name?.split(' ')[0]}
                </span>
              </Link> : <Link to="/login" className="hidden sm:flex items-center gap-2 text-gray-700 hover:text-primary-600 transition-colors" data-id="element-393" data-mp="1663ec0szkmlf">
                <UserIcon className="w-5 h-5" data-id="element-394" data-mp="s5sn2wnrl5zq" />
                <span className="text-sm font-medium" data-id="element-395" data-mp="x5os8z8773gv">Login / Register</span>
              </Link>}

            <Link to="/wishlist" className="hidden sm:flex p-2 text-gray-700 hover:text-primary-600 transition-colors relative" aria-label="Wishlist" data-id="element-396" data-mp="x7hxqb72rhna">
              <HeartIcon className="w-5 h-5" data-id="element-397" data-mp="3hwp9p8qm1qz3" />
            </Link>

            <Link to="/cart" className="flex items-center gap-2 bg-primary-600 text-white px-3 py-2 rounded-lg hover:bg-primary-700 transition-colors" aria-label={`Shopping cart with ${itemCount} items`} data-id="element-398" data-mp="zwvtud1vgdk">
              <ShoppingCartIcon className="w-5 h-5" data-id="element-399" data-mp="3ocpqkfwqniy2" />
              <span className="font-medium" data-id="element-400" data-mp="3ob4uglurzry3">{formatPrice(total)}</span>
              {itemCount > 0 && <span className="bg-white text-primary-600 text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center" data-id="element-401" data-mp="3jfzahskxoncn">
                  {itemCount}
                </span>}
            </Link>

            {/* Mobile menu button */}
            <button className="md:hidden p-2 text-gray-700" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-402" data-mp="ay2v047h28eq">
              {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-403" data-mp="5z019fwxzom2" /> : <MenuIcon className="w-6 h-6" data-id="element-404" data-mp="2vok0ddmx11qu" />}
            </button>
          </div>
        </div>

        {/* Mobile search */}
        <div className="mt-4 md:hidden" data-id="element-405" data-mp="2qp7fuzjio6rf">
          <Input type="search" placeholder="Search products..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} leftIcon={<SearchIcon className="w-5 h-5" data-id="element-407" data-mp="2lkdgqpl2qo16" />} data-id="element-406" data-mp="2qo5wm7sckdym" />
        </div>
      </div>

      {/* Mobile menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-white border-t border-gray-100 py-4" data-id="element-408" data-mp="2qjgahdvlt7tu">
          <nav className="max-w-7xl mx-auto px-4 space-y-2" data-id="element-409" data-mp="2vaga4qw3y401">
            <Link to="/login" className="flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg" onClick={() => setIsMobileMenuOpen(false)} data-id="element-410" data-mp="2vbrashu9avmx">
              <UserIcon className="w-5 h-5" data-id="element-411" data-mp="34abmgz1eg51n" />
              Login / Register
            </Link>
            <Link to="/wishlist" className="flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg" onClick={() => setIsMobileMenuOpen(false)} data-id="element-412" data-mp="399y0hap1xpbi">
              <HeartIcon className="w-5 h-5" data-id="element-413" data-mp="3e6y47eyfifzg" />
              Wishlist
            </Link>
          </nav>
        </div>}
    </header>;
}